module.exports = __webpack_public_path__ + "img/photosession_1_7.02d40790.jpg";